import TextInput from "./TextInput";
import { phoneMask } from "../../utils/masks";

function PhoneOrExtInput({ ...props }) {
    return <TextInput mask={phoneMask} {...props} />;
}

export default PhoneOrExtInput;
